import { useMutation } from '@tanstack/react-query';
import { useShowErrorToast } from '@utils/formHelpers';
import { queryFetch } from '@services/api';
import { TaskReq } from './types';
import { useJobRefetch } from '@hooks/job/refetch';
import { DefaultApiResp } from '@root/globalTypes';

export const useRemoveTask = (stageId: string) => {
  const { refetch, stages } = useJobRefetch();
  const { showErrorToast } = useShowErrorToast();

  const { mutate, isPending } = useMutation({
    mutationFn: ({ jobId, id }: TaskReq): Promise<DefaultApiResp> =>
      queryFetch({ url: `jobs/${jobId}/tasks/${id}`, opt: { method: 'DELETE' } }),
    onMutate: async ({ jobId, id }) =>
      stages.update({
        jobId,
        stage: {
          id: stageId,
          tasks: stages
            .get(jobId)
            .find((el) => el.id === stageId)
            ?.tasks.map((el) => ({
              ...el,
              tasks: el.tasks.filter((task) => task.id !== id),
            })),
        },
      }),
    onError: (err) => {
      console.error(err);
    },
    onSuccess: async ({ success }) => {
      if (!success) return;
      await refetch();
    },
    onSettled: (data, _, { jobId }, prev) => {
      const { errors } = data as DefaultApiResp;
      if (errors) {
        stages.restore(jobId, prev);
        showErrorToast(errors);
      }
    },
  });

  return {
    mutate,
    isLoading: isPending,
  };
};
